module.exports = __webpack_public_path__ + "static/img/image_news_01.f63c061.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/news/image_news_01.png
// module id = 0d34
// module chunks = 10